export default [
    {
        path: 'profile',
        name: 'user.profile',
        component: () => import('@/views/user/Profile.vue'),
    }
];

